var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFashioninline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M32 59V43m0-38h2.75q-.687 4.385 1.375 4.385c2.063 0 6.875.73 6.875 4.384s-4.125 6.32-4.125 11.693 3.438 7.307 3.438 12.423q0 5.115-3.438 5.115h-13.75q-3.438 0-3.438-5.115c0-5.116 3.438-7.05 3.438-12.423S21 17.423 21 13.769s4.813-4.384 6.875-4.384q2.062 0 1.375-4.385zM22 59h20"
})));
export default SvgFashioninline;